import { render, staticRenderFns } from "./wordCloud.vue?vue&type=template&id=52857f68&scoped=true"
import script from "./wordCloud.vue?vue&type=script&lang=js"
export * from "./wordCloud.vue?vue&type=script&lang=js"
import style0 from "./wordCloud.vue?vue&type=style&index=0&id=52857f68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52857f68",
  null
  
)

export default component.exports